import { gql } from '@apollo/client';

export const FETCH_ALL_CONSENTS_QUERY = gql`
  query fetchReceivedConsents(
    $consentType: ConsentType
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchReceivedConsents(
      consentType: $consentType
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      consentList
      count
    }
  }
`;
